"use strict";
exports.__esModule = true;
exports.createCategoryLegendItems = exports.GeoChartOptionsWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var common_1 = require("./helpers/geoChart/common");
var data_1 = require("./helpers/geoChart/data");
var GeoChartInner_1 = require("./GeoChartInner");
var geoChart_1 = require("./constants/geoChart");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var geoChart_2 = require("./colorStrategy/geoChart");
var GeoChartOptionsWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(GeoChartOptionsWrapper, _super);
    function GeoChartOptionsWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.buildGeoChartOptions = function (geoData, props) {
            var segment = geoData.segment;
            var _a = props.config, _b = _a === void 0 ? {} : _a, _c = _b.colors, colors = _c === void 0 ? [] : _c, _d = _b.colorPalette, colorPalette = _d === void 0 ? [] : _d, _e = _b.colorMapping, colorMapping = _e === void 0 ? [] : _e, dataView = props.dataView;
            var dv = sdk_ui_1.DataViewFacade["for"](dataView);
            var palette = sdk_ui_vis_commons_1.getValidColorPalette(colors, colorPalette);
            var colorStrategy = geoChart_2.getColorStrategy(palette, colorMapping, geoData, dv);
            var categoryItems = segment ? _this.getCategoryLegendItems(colorStrategy) : [];
            return {
                geoData: geoData,
                categoryItems: categoryItems,
                colorStrategy: colorStrategy,
                colorPalette: palette
            };
        };
        _this.validateData = function (geoData, props) {
            var _a, _b;
            if (!props.dataView) {
                return;
            }
            var dataView = props.dataView;
            var limit = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.limit) !== null && _b !== void 0 ? _b : geoChart_1.DEFAULT_DATA_POINTS_LIMIT;
            var dv = sdk_ui_1.DataViewFacade["for"](dataView);
            return {
                isDataTooLarge: !common_1.isDataOfReasonableSize(dv, geoData, limit)
            };
        };
        _this.emptyHeaderString = props.intl.formatMessage({ id: "visualization.emptyValue" });
        _this.nullHeaderString = props.intl.formatMessage({ id: "visualization.emptyValue" }); // TODO: RAIL-4360 replace by proper null header string id when available
        _this.errorMap = sdk_ui_1.newErrorMapping(props.intl);
        return _this;
    }
    GeoChartOptionsWrapper.prototype.render = function () {
        var _a, _b;
        var _c = this.props, dataView = _c.dataView, error = _c.error, isLoading = _c.isLoading;
        // if explicitly null, do not default the components to allow them to be disabled
        var ErrorComponent = this.props.ErrorComponent === null ? null : (_a = this.props.ErrorComponent) !== null && _a !== void 0 ? _a : sdk_ui_1.ErrorComponent;
        var LoadingComponent = this.props.LoadingComponent === null
            ? null
            : (_b = this.props.LoadingComponent) !== null && _b !== void 0 ? _b : sdk_ui_1.LoadingComponent;
        if (error) {
            var errorProps = this.errorMap[Object.prototype.hasOwnProperty.call(this.errorMap, error)
                ? error
                : sdk_ui_1.ErrorCodes.UNKNOWN_ERROR];
            return ErrorComponent ? react_1["default"].createElement(ErrorComponent, tslib_1.__assign({ code: error }, errorProps)) : null;
        }
        if (isLoading || !dataView) {
            return LoadingComponent ? react_1["default"].createElement(LoadingComponent, null) : null;
        }
        return this.renderVisualization();
    };
    GeoChartOptionsWrapper.prototype.renderVisualization = function () {
        var _a = this.props, dataView = _a.dataView, onDataTooLarge = _a.onDataTooLarge;
        var dv = sdk_ui_1.DataViewFacade["for"](dataView);
        var geoData = data_1.getGeoData(dv, this.emptyHeaderString, this.nullHeaderString);
        var validationResult = this.validateData(geoData, this.props);
        if (validationResult === null || validationResult === void 0 ? void 0 : validationResult.isDataTooLarge) {
            ts_invariant_1["default"](onDataTooLarge, "GeoChart's onDataTooLarge callback is missing.");
            onDataTooLarge();
            return null;
        }
        var geoChartOptions = this.buildGeoChartOptions(geoData, this.props);
        return react_1["default"].createElement(GeoChartInner_1.GeoChartInner, tslib_1.__assign({}, this.props, { geoChartOptions: geoChartOptions }));
    };
    GeoChartOptionsWrapper.prototype.getCategoryLegendItems = function (colorStrategy) {
        return createCategoryLegendItems(colorStrategy, this.emptyHeaderString, this.nullHeaderString);
    };
    return GeoChartOptionsWrapper;
}(react_1["default"].Component));
exports.GeoChartOptionsWrapper = GeoChartOptionsWrapper;
function createCategoryLegendItems(colorStrategy, emptyHeaderString, nullHeaderString) {
    var colorAssignment = colorStrategy.getColorAssignment();
    return colorAssignment.map(function (item, legendIndex) {
        var _a = sdk_model_1.isResultAttributeHeader(item.headerItem)
            ? item.headerItem.attributeHeaderItem
            : { name: emptyHeaderString, uri: emptyHeaderString }, name = _a.name, uri = _a.uri;
        var color = colorStrategy.getColorByIndex(legendIndex);
        return {
            uri: uri !== null && uri !== void 0 ? uri : nullHeaderString,
            name: name !== null && name !== void 0 ? name : nullHeaderString,
            color: color,
            legendIndex: legendIndex,
            isVisible: true
        };
    });
}
exports.createCategoryLegendItems = createCategoryLegendItems;
//# sourceMappingURL=GeoChartOptionsWrapper.js.map